export default __webpack_public_path__ + "static/media/18.f068f8eb.png";